import axios from 'axios'

export default {
  ListCombo () {
    return new Promise((resolve, reject) => {
      // Recupera del cache la list de items
      const storage = sessionStorage.getItem('pos_eventos_itemscombo')

      // Si ya estan los datos en el storage, se retorna de ahi, solo para las paramtétricas
      if (storage)
        resolve(JSON.parse(storage))
      else {
        // realizo el llamado ajax
        const p = axios.get('/api/pos_eventos/ListCombo')

        p.then(({ data }) => {
          sessionStorage.setItem('pos_eventos_itemscombo', JSON.stringify(data.recordset))
          resolve(data.recordset)
        }).catch((err) => {
          reject(err)
        })
      }
    })
  },
  List (params) {
    return axios.get('/api/pos_eventos/List', { params })
  },
  Agregar (params) {
    return axios.post('/api/pos_eventos', params)
  },
  Modificar (params) {
    return axios.put('/api/pos_eventos', params)
  },
  Borrar (params) {
    return axios.delete('/api/pos_eventos', { params })
  }
}
